module.exports = __webpack_public_path__ + "img/employeePayrollSettings.485b4ac9.svg";